import { styled } from 'styled-components';

export const ScMissions = styled.div`
  display: flex;
  align-items: center;
  overflow: auto;
  scroll-snap-type: x mandatory;
  margin-bottom: 16px;
  padding: 0 65px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  & .mission {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
    scroll-snap-align: center;
    flex: 0 0 250px;
    gap: 20px;

    &:first-child .mission-stage-info::before {
      display: none;
    }

    &:last-child .mission-stage-info::after {
      display: none;
    }

    & .img-container {
      position: relative;
    }

    & img {
      width: 168px;
      height: 168px;
    }

    & .tick-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: none;
      width: 39px;
      height: 39px;
      justify-content: center;
      align-items: center;
      border-radius: 360px;
      background: ${({ theme }) => theme.greenSuccessColor};
    }

    &:not(.active) .img-container {
      margin-top: 32px;
    }
  }

  & .mission.locked {
    & .mission-stage-info {
      border: 1px solid #8e8e93;

      &::before,
      &::after {
        background: #8e8e93;
      }
    }

    & .status {
      color: #8e8e93;
    }
  }

  & .mission.active {
    & .mission-stage-info {
      border: 1px solid #ea5b0c;

      &::before {
        background: #ea5b0c;
      }

      &::after {
        background: linear-gradient(90deg, #ea5b0c 0%, #8e8e93 100%);
      }
    }

    & .status {
      color: #ea5b0c;
    }

    & img {
      width: 220px;
      height: 220px;
    }
  }

  & .mission.claimed {
    & .mission-stage-info {
      border: 1px solid #ea5b0c;

      &::before,
      &::after {
        background: #ea5b0c;
      }
    }

    & .status {
      color: ${({ theme }) => theme.greenSuccessColor};
    }

    & .tick-icon {
      display: flex;
    }
  }

  & .mission-stage-info {
    position: relative;
    display: flex;
    width: 138px;
    height: 86px;
    padding: 8px 0;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    border-radius: 8px;

    &::before {
      content: "";
      display: block;
      height: 1px;
      width: 58px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 100%;
    }

    &::after {
      content: "";
      display: block;
      height: 1px;
      width: 57px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 100%;
    }

    & .status {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
      letter-spacing: 0px;
      text-transform: uppercase;
    }

    & .lvl {
      color: #8e8e93;
      text-align: right;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 0;
    }
  }
`;
